import Policy from './Policy'

// Backend policies resolved in: backend/components/api_core/app/presenters/api_core/employee_policies_presenter.rb
export type EmployeeVerbTypes =
  | 'addCustomTablesRecords'
  | 'editDocuments'
  | 'editPersonal'
  | 'manageIncidences'
  | 'manageLeavesDocuments'
  | 'manageTasks'
  | 'readDocuments'
  | 'readLeaves'
  | 'readUserPayrollObservations'
  | 'removeCustomTablesRecords'
  | 'sharePreferredName'
  | 'shareProfileEmail'
  | 'terminateEmployee'

class EmployeePolicy extends Policy<EmployeeVerbTypes> {
  checkVerb(verb: EmployeeVerbTypes): boolean {
    switch (verb) {
      case 'addCustomTablesRecords':
        return this.permissions.custom_tables.create

      case 'editDocuments':
        return this.permissions.documents.edit

      case 'editPersonal':
        return this.permissions.personal.edit

      case 'manageIncidences':
        return this.permissions.leaves.manage_incidences

      case 'manageLeavesDocuments':
        return this.permissions.leaves.manage_documents

      case 'manageTasks':
        return this.permissions.tasks.read

      case 'readDocuments':
        return this.permissions.documents.read

      case 'readLeaves':
        return this.permissions.leaves.read

      case 'readUserPayrollObservations':
        return this.permissions.payroll_supplements.observations.read

      case 'removeCustomTablesRecords':
        return this.permissions.custom_tables.remove

      case 'sharePreferredName':
        return this.permissions.preferred_name.read

      case 'shareProfileEmail':
        return this.permissions.profile.email.read

      case 'terminateEmployee':
        return this.permissions.termination

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default EmployeePolicy
